const WhyGrowContent = () => (
    <div className="section-content">
        <h2>Why Grow Your Food?</h2>

        <p>
            Food prices keep rising - but your garden, balcony, or patio can become
            your first stop for groceries. <strong>GrowYourFoodApp</strong> makes
            year-round growing simple in our climate, guiding you on when to plant,
            protect, harvest, and preserve.
        </p>

        <ul>
            <li><strong>Save money</strong> by harvesting before you shop.</li>
            <li><strong>Eat fresher</strong> by planning meals around what's ready now.</li>
            <li><strong>Build abundance</strong> by preserving surplus harvests for your pantry.</li>
            <li>
                <strong>Shape the future</strong> - today it's your Garden Companion,
                tomorrow it's a lifestyle and local food ecosystem.
            </li>
        </ul>

        <p>
            Start now, be part of the journey, and remember the name:
            <strong> GrowYourFoodApp</strong>.
        </p>
    </div>
);
export default WhyGrowContent;
